<h2 mat-dialog-title>Geen factuur</h2>

<mat-dialog-content>
    <p class="no-invoice-intro">Geef de reden op waarom er geen factuur is voor dit project.</p>

    <div class="no-invoice-field">
        <label class="no-invoice-label">Reden <span class="no-invoice-required">*</span></label>
        <textarea
            [(ngModel)]="reason"
            class="no-invoice-textarea"
            rows="4"
            placeholder="Bv. pro bono, intern project, al gefactureerd via ander kanaal…"></textarea>
    </div>

    <div class="no-invoice-attachment">
        <label class="no-invoice-label">Bijlage <span class="no-invoice-optional">(optioneel)</span></label>
        <div class="no-invoice-file-row">
            <input #fileInput type="file" accept="image/*,application/pdf" (change)="onFileSelected($event)" class="no-invoice-file-input-hidden" />
            <button mat-stroked-button type="button" (click)="fileInput.click()">Bestand kiezen</button>
            <span class="no-invoice-file-name" *ngIf="attachment">{{ attachment.name }}</span>
            <span class="no-invoice-file-name" *ngIf="!attachment">Geen bestand gekozen</span>
        </div>
        <a *ngIf="!attachment && existingAttachmentUrl" [href]="existingAttachmentUrl" target="_blank" rel="noopener" class="no-invoice-existing-link">
            Huidige bijlage bekijken
        </a>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Annuleren</button>
    <button mat-raised-button color="primary" (click)="submit()" [disabled]="!canSubmit()">Opslaan</button>
</mat-dialog-actions>
